import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Debug helper for panopticon e2e — exposes a fn from bundle code so
// REPL calls produce a real bundle frame (not <anonymous>) and the
// uploaded sourcemap can resolve it back to this file.
if (typeof window !== "undefined") window.__pTest = () => null.foo
